<template src="./ExcludedSites.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import SearchQuery from "@/components/suppliers/components/SearchQuery"
import TopMenu from "@/components/suppliers/components/topMenu"

const {mapGetters, mapActions} = createNamespacedHelpers('suppliers/excludedSites');

export default {
  name: "SuppliersExcluded",
  components: {
    SearchQuery,
    TopMenu,
  },
  data() {
    return {
      showOverlay: false,
      timer: null,
    }
  },
  methods: {
    ...mapActions(['SAVE', 'GET_DATA']),
    change() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.SAVE({th: this})
      }, 1500)
    },
    getData() {
      this.GET_DATA({th: this})
    },
  },
  computed: {
    ...mapGetters([
      'EXCLUDED_SITES',
    ]),
  },
  mounted() {
    this.getData()
  },
  created() {
    if (this.$store.getters.getAllowSection.indexOf('suppliers') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
}
</script>

<style scoped>

.input-add-use {
  text-align: left;
}

.submit-button {
  text-align: right;
}

</style>